var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-pagination',_vm._b({on:{"input":_vm.change}},'gl-pagination',_vm.glPaginationProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }